import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';

export const LogButton = styled.button`
    margin: 0;
    border: none;
    outline: none;
    padding-right: 0;
    font-size: 1.15rem;
    background-color: transparent;
    color: ${theme.palette.primaryIconSolid};

    i {
        vertical-align: bottom;
    }

    &:hover {
        cursor: pointer;
        color: ${theme.palette.primaryIconHover};
    }
`;

export const LogExportWrapper = styled.div`
    padding-top: 0.125rem;

    .white-tooltip {
        font-size: 0.625rem;

        > span {
            color: ${theme.palette.white};
        }
    }
`;
